"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _moment = _interopRequireDefault(require("moment"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
var _default2 = exports.default = {
  name: 'LotsList',
  props: {
    lots: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    isLoading: {
      type: Boolean,
      default: false
    },
    value: {
      type: Object,
      default: function _default() {
        return null;
      }
    }
  },
  data: function data() {
    return {
      searchQuery: '',
      selectedLot: this.value
    };
  },
  watch: {
    searchQuery: function searchQuery(newQuery) {
      this.$emit('onSearchChange', newQuery);
    },
    selectedLot: function selectedLot(newLot) {
      this.$emit('input', newLot);
      this.$emit('select', newLot);
    },
    value: function value(newValue) {
      this.selectedLot = newValue;
    }
  },
  methods: {
    handleRowClick: function handleRowClick(row) {
      this.selectedLot = row;
    },
    formatType: function formatType(lot) {
      if (lot.cutting) {
        return 'Estaquia';
      }
      if (lot.rootstock) {
        return 'Enxertia';
      }
      return '--';
    },
    formatStage: function formatStage(lot) {
      var _lot$stage;
      var stageName = (_lot$stage = lot.stage) === null || _lot$stage === void 0 ? void 0 : _lot$stage.stageName;
      if (stageName === 'planting') return 'Plantio';
      if (stageName === 'grafting') return 'Enxertia';
      if (stageName === 'regrafting') return 'Re-enxertia';
      return stageName || '--';
    },
    formatVarietyName: function formatVarietyName(lot) {
      var _lot$cutting, _lot$rootstock, _lot$scion, _lot$rootstock3;
      if ((_lot$cutting = lot.cutting) !== null && _lot$cutting !== void 0 && _lot$cutting.name) {
        var _lot$cutting2;
        return (_lot$cutting2 = lot.cutting) === null || _lot$cutting2 === void 0 ? void 0 : _lot$cutting2.name;
      }
      if ((_lot$rootstock = lot.rootstock) !== null && _lot$rootstock !== void 0 && _lot$rootstock.name && (_lot$scion = lot.scion) !== null && _lot$scion !== void 0 && _lot$scion.name) {
        var _lot$rootstock2, _lot$scion2;
        return "".concat((_lot$rootstock2 = lot.rootstock) === null || _lot$rootstock2 === void 0 ? void 0 : _lot$rootstock2.name, "-").concat((_lot$scion2 = lot.scion) === null || _lot$scion2 === void 0 ? void 0 : _lot$scion2.name);
      }
      return ((_lot$rootstock3 = lot.rootstock) === null || _lot$rootstock3 === void 0 ? void 0 : _lot$rootstock3.name) || '--';
    },
    formatPlaces: function formatPlaces(lot) {
      var inventories = Array.isArray(lot === null || lot === void 0 ? void 0 : lot.inventories) ? lot.inventories : [];
      return inventories.map(function (inventory) {
        var _inventory$section, _inventory$row, _inventory$quantity;
        var section = (inventory === null || inventory === void 0 ? void 0 : (_inventory$section = inventory.section) === null || _inventory$section === void 0 ? void 0 : _inventory$section.name) || '';
        var row = (inventory === null || inventory === void 0 ? void 0 : (_inventory$row = inventory.row) === null || _inventory$row === void 0 ? void 0 : _inventory$row.name) || '';
        var quantity = (_inventory$quantity = inventory === null || inventory === void 0 ? void 0 : inventory.quantity) !== null && _inventory$quantity !== void 0 ? _inventory$quantity : 0;
        var label = [section, row].filter(Boolean).join(' · ') || row;
        return label ? "".concat(label, " (").concat(quantity, ")") : null;
      }).filter(Boolean);
    },
    formatDate: function formatDate(date) {
      if (!date) return '--';
      return (0, _moment.default)(date).format('DD/MM/YYYY');
    }
  }
};